import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import * as React from 'react';
import updateTrfFileStatus from '../actions/admin/updateTrfFileStatus';
import { handleDownload } from '../helpers/handleDownload';
import { Kit } from '../hooks/useKits';
import { ReactComponent as DownloadIcon } from '../icons/download.svg';
import useStore from '../store/store';
import Button from './Button';
import Dialog from './Dialog';

interface ViewTRFDialogProps {
    kit: Kit;
    open: boolean;
    onClose: () => void;
    onSubmit: () => void;
}

const ViewTRFDialog = ({
    kit,
    open,
    onClose,
    onSubmit,
}: ViewTRFDialogProps) => {
    const isLoading = useStore((state) => state.isLoading);
    const [status, setStatus] = React.useState<
        '' | 'submitted' | 'valid' | 'invalid'
    >(kit.TrfFileStatus ?? '');

    React.useEffect(() => {
        if (open) {
            setStatus(kit.TrfFileStatus ?? '');
        }
    }, [open, kit.TrfFileStatus]);

    const handleClose = () => {
        if (isLoading) {
            return;
        }
        onClose();
    };

    const handleSubmit = async (e: React.SyntheticEvent) => {
        e.preventDefault();

        await updateTrfFileStatus({
            kitId: kit.KitId,
            status: status as 'valid' | 'invalid',
        });

        onSubmit();
        handleClose();
    };

    return (
        kit && (
            <Dialog
                open={open}
                onClose={handleClose}
                title={'Verify TRF'}
                onSubmit={handleSubmit}
                submitDisabled={
                    isLoading || (status !== 'valid' && status !== 'invalid')
                }
                key={kit.KitId}
            >
                <div style={{ marginBottom: '8px' }}>
                    <Button
                        onClick={() => handleDownload(kit.TrfFilePath!, true)}
                        disabled={!kit.TrfFilePath}
                        size="small"
                        icon={<DownloadIcon />}
                    >
                        {kit.TrfFilePath ? 'Download' : 'No TRF file'}
                    </Button>
                </div>
                <FormControl fullWidth margin="dense">
                    <InputLabel id="status-select-label">Status</InputLabel>
                    <Select
                        id="status-select"
                        name="status"
                        label="Status"
                        onChange={(e) =>
                            setStatus(
                                e.target.value as
                                    | 'submitted'
                                    | 'valid'
                                    | 'invalid'
                            )
                        }
                        required
                        value={status}
                    >
                        <MenuItem value="submitted">Submitted</MenuItem>
                        <MenuItem value="invalid">Invalid</MenuItem>
                        <MenuItem value="valid">Valid</MenuItem>
                    </Select>
                </FormControl>
            </Dialog>
        )
    );
};

export default ViewTRFDialog;
